import { useMediaQuery } from '@helpers/hooks'
import { BREAKPOINT_SIZES } from '@consts/index'
import { ReactComponent as ChevronIcon } from '@svgs/keyline/arrow-next.svg'
import styles from './styles.module.scss'
import ButtonMinimal from '@components/ui/Button/ButtonMinimal'

type FlashBannerButtonProps = {
  linkTextDesktop: string
}

function FlashBannerButton({ linkTextDesktop }: FlashBannerButtonProps) {
  const isPhabletUp = useMediaQuery({ minWidth: BREAKPOINT_SIZES.PHABLET })

  return (
    <div className={styles.flashLinkWrapper}>
      {isPhabletUp ? (
        <ButtonMinimal variant="white" underlined>
          {linkTextDesktop}
        </ButtonMinimal>
      ) : (
        <div className={styles.flashLink__icon}>
          <ChevronIcon stroke="currentColor" />
        </div>
      )}
    </div>
  )
}

export default FlashBannerButton
